import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconRefresh: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m5 5.66666667h3.11111111c.24545989 0 .44960837.17687516.49194433.41012436l.00805567.08987564v3.11111111c0 .27614237-.22385762.5-.5.5-.24545989 0-.44960837-.17687516-.49194433-.41012437l-.00805567-.08987563-.00026465-2.07248185c-1.32858232 1.21570473-2.11084646 2.93947347-2.11084646 4.79470407 0 3.5898509 2.91014913 6.5 6.5 6.5.2761424 0 .5.2238576.5.5s-.2238576.5-.5.5c-4.14213562 0-7.5-3.3578644-7.5-7.5 0-2.04111628.82152839-3.94552308 2.22697382-5.3339303l-1.72697382.00059697c-.27614237 0-.5-.22385763-.5-.5 0-.24545989.17687516-.44960837.41012437-.49194433l.08987563-.00805567h3.11111111zm7-1.16666667c4.1421356 0 7.5 3.35786438 7.5 7.5 0 2.5600803-1.2938419 4.8952886-3.3796202 6.2678291l1.7129535-.0011624c.2761424 0 .5.2238576.5.5 0 .2761423-.2238576.5-.5.5h-3.1111111c-.2761424 0-.5-.2238577-.5-.5v-3.1111111c0-.2761424.2238576-.5.5-.5s.5.2238576.5.5l.0002495 1.990793c.0105849-.006055.0211529-.01214.0317041-.0182549 1.9931188-1.1551066 3.2458242-3.2822382 3.2458242-5.6280937 0-3.58985087-2.9101491-6.5-6.5-6.5-.472766 0-.9386642.05038952-1.3923501.14936492-.2697968.05885844-.5362244-.11214085-.5950829-.38193762-.05885843-.26979676.1121409-.53622445.3819376-.5950829.5235945-.11422655 1.0609484-.1723444 1.6054954-.1723444z"
        fill="#132122"
        fillRule="evenodd"
        transform="translate(-4 -4)"
      />
    </svg>
  </IconStyled>
);

IconRefresh.defaultProps = iconDefaultProps;
IconRefresh.displayName = 'IconRefresh';

export default IconRefresh;
